import tag from './Tag/Tag';

export default { tag };